import React from "react";

// react-bootstrap components
import {
  Container
} from "react-bootstrap";

function AuthFooter() {
  return (
    <>
      <footer className="footer position-absolute fixed-bottom">
        <Container>
          <nav>
            <p className="copyright text-center m-0">
              © {new Date().getFullYear()}{" "}
              <a href="http://www,arktci.com">ARK TCI</a>
            </p>
          </nav>
        </Container>
      </footer>
    </>
  );
}

export default AuthFooter;
